import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import { DecisionMakerData } from './api.graphql';
import type { DecisionMakerDataQuery, DecisionMakerDataQueryVariables } from './api.graphql';
import type { DecisionMakerProfilePageData } from './types';

export async function getDecisionMakerProfilePageData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
): Promise<DecisionMakerProfilePageData> {
	const { data } = await fetch<DecisionMakerDataQuery, DecisionMakerDataQueryVariables>({
		query: DecisionMakerData,
		variables: { slug },
		rejectOnError: true,
	});

	if (!data.decisionMaker) throw new NotFoundError();
	if (!data.decisionMaker.publiclyVisible) throw new NotFoundError();

	return {
		...data.decisionMaker,
		description: data.decisionMaker.description || '',
		title: data.decisionMaker.title || '',
		featureConfigs: data.featureConfigs,
	};
}
